import * as React from 'react';

import { getSessionVal, setSessionVal } from '../storage/storage-utils';
import { navigateTop } from '../routing/router-utils';
import { UserContext } from '../providers/UserProvider';
import { OrderContext } from '../orders/OrderProvider';
import { trackEvent } from '../analytics/tracking';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

import styles from './footer.module.css';

const ReorderBar = () => {

  const storageKey = 'hideReorderBar';

  // Only display bar for anonymous users
  const { user } = React.useContext(UserContext);

  const { disableReorder } = React.useContext(OrderContext);
  
  const handleClose = () => {
    setShowBar(false);
    setSessionVal(storageKey, true);
    trackEvent('signup_bar_close'); 
  };

  const [showBar, setShowBar] = React.useState(); 
  React.useEffect(() => {
    const disabledForSession = !!getSessionVal(storageKey);
    const disableBar = (user && user.isAnonymous) || disableReorder || disabledForSession;
    if (disableBar) {
      setShowBar(false);
    } else {
      setShowBar(true);
    }
  }, [user, disableReorder]);

  return ( showBar
    ? <div className={styles.signUpBar}>
        <div className={styles.close} onClick={handleClose}>
          <HighlightOffRoundedIcon style={{verticalAlign:'-6px', fontSize: '22px', color: '#ccc'}} />
        </div>
        <div className={styles.text}>Need to reorder? it's easy!</div>
        <div className={styles.actions}>
          <span className={styles.btn} onClick={() => {
            navigateTop('/your/orders');
            trackEvent('reorder_bar_click');
            // No need to show prompt again in session
            setSessionVal(storageKey, true);    
          }}>Reorder</span> 
        </div>
      </div>
    : null
  );
};

export default ReorderBar;